<template>
  <PflegeCard
    v-editable="props.blok"
    class="card"
    :heading="props.blok.heading"
    :text-align="props.blok.textAlign"
    :figure-position="props.blok.imagePosition"
    :background-color="utils.getPflegeColornameFromHex(props.blok.backgroundColor.value)"
    :data-uid="props.blok._uid"
  >
    <WizcoRichtextResolver :blok="props.blok.content" />
    <template v-if="props.blok.image?.filename" #figure>
      <img
        :src="props.blok.image.filename"
        :alt="props.blok.image.alt"
        :title="props.blok.image.title"
        :data-copyright="props.blok.image.copyright"
        loading="lazy"
      />
    </template>
    <template v-if="props.blok.actions" #actions>
      <WizcoWPElementButton
        v-for="button in props.blok.actions"
        :key="button._uid"
        :blok="button"
      />
    </template>
  </PflegeCard>
</template>

<script setup>
import usePflegeUtils from '../../../composable/usePflegeUtils'

const props = defineProps({
  blok: {
    type: Object,
    required: true
  }
})

const utils = usePflegeUtils()
</script>

<style scoped>
.card footer {
  display: flex;
  justify-content: v-bind('props.blok.textAlign');
  gap: 1rem;
}

@media (max-width: 576px) {
  .card {
    flex-direction: column;
  }

  .card footer {
    display: flex;
    gap: 0;
    flex-direction: column;
  }
}
</style>
